import { render, staticRenderFns } from "./SelectStatusFinance.vue?vue&type=template&id=1dded91f&"
import script from "./SelectStatusFinance.vue?vue&type=script&lang=ts&"
export * from "./SelectStatusFinance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports